import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const ReminderDialog = ({ inv, onClose, onSent }) => {
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!inv) { setF(null); return; }
    api.get(`/fic/invoices/${inv.id}/reminder`).then((r) => setF(r.data)).catch((e) => { toast.error(errorMessage(e)); onClose(); });
  }, [inv]); // eslint-disable-line react-hooks/exhaustive-deps
  const send = async () => {
    setBusy(true);
    try { await api.post(`/fic/invoices/${inv.id}/reminder`, { to: f.to.trim(), subject: f.subject, body: f.body }); toast.success(`Sollecito inviato a ${f.to}`); onSent?.(); onClose(); }
    catch (e) { toast.error(errorMessage(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={!!inv} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-2xl" data-testid="reminder-dialog">
        <DialogHeader><DialogTitle>Sollecito di pagamento · fattura {inv?.number}</DialogTitle>
          <DialogDescription>Inviato da staff@gruppo-on.it con il PDF della fattura allegato.{f?.reminders_count ? ` Solleciti gi\u00e0 inviati: ${f.reminders_count}, l'ultimo il ${fmtDateTime(f.last_reminder_at)}.` : ""}</DialogDescription></DialogHeader>
        {!f ? <p className="py-6 text-center text-sm text-slate-500">Preparazione…</p> : <div className="space-y-3">
          <div className="space-y-1.5"><Label className="text-xs">Destinatario{f.to_source === "pec" ? " (PEC: email cliente non indicata)" : ""}</Label>
            <Input value={f.to} onChange={(e) => setF({ ...f, to: e.target.value })} maxLength={200} data-testid="reminder-to" />
            {!f.to && <p className="text-xs text-red-600">Nessuna email o PEC in scheda cliente: indicane una.</p>}</div>
          <div className="space-y-1.5"><Label className="text-xs">Oggetto</Label><Input value={f.subject} onChange={(e) => setF({ ...f, subject: e.target.value })} maxLength={200} data-testid="reminder-subject" /></div>
          <div className="space-y-1.5"><Label className="text-xs">Testo</Label><Textarea rows={12} value={f.body} onChange={(e) => setF({ ...f, body: e.target.value })} maxLength={5000} data-testid="reminder-body" /></div>
        </div>}
        <DialogFooter><Button variant="outline" onClick={onClose}>Annulla</Button>
          <Button disabled={busy || !f?.to?.includes("@") || !f?.subject || !f?.body} onClick={send} data-testid="reminder-send">{busy ? "Invio…" : "Invia sollecito"}</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
